var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#BABDCC",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 1.8h-1.65c-.083 0-.15-.067-.15-.15V.6c0-.331-.269-.6-.6-.6-.331 0-.6.269-.6.6v2.85c0 .249-.201.45-.45.45S9 3.699 9 3.45V2.1c0-.166-.134-.3-.3-.3H4.95c-.083 0-.15-.067-.15-.15V.6c0-.331-.269-.6-.6-.6-.331 0-.6.269-.6.6v2.85c0 .249-.201.45-.45.45s-.45-.201-.45-.45V2.1c0-.166-.134-.3-.3-.3h-.9C.837 1.8.3 2.337.3 3v10.2c0 .663.537 1.2 1.2 1.2h11.4c.663 0 1.2-.537 1.2-1.2V3c0-.663-.537-1.2-1.2-1.2zm-.3 11.4H1.8c-.166 0-.3-.134-.3-.3V5.7c0-.166.134-.3.3-.3h10.8c.166 0 .3.134.3.3v7.2c0 .166-.134.3-.3.3z",
    transform: "translate(-384 -202) translate(370 190) translate(14 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a940240f4112365e58c698f00d0d4fda.svg";
export { ForwardRef as ReactComponent };